import axios from 'axios'

import { ApiSourceType } from '~sharedLib'
import { addBaseInterceptors } from '../../lib/functions/addBaseInterceptors'
import { baseConfig } from '../axios/base'

export const firstSourceInstanceApi = axios.create(baseConfig(ApiSourceType.First))

addBaseInterceptors(firstSourceInstanceApi.interceptors)
